import { publicNavLinks } from "@/mocks/publico";

const LOGO_URL =
  "https://static.readdy.ai/image/f0e3ea51be3a6053767e026ea9261140/5c6a1513dcc1f5b9c75447af1cdc9373.png";

interface PublicFooterProps {
  onNavigate: (href: string) => void;
}

export default function PublicFooter({ onNavigate }: PublicFooterProps) {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <a
              href="#inicio"
              onClick={(e) => {
                e.preventDefault();
                onNavigate("#inicio");
              }}
              className="inline-block mb-4"
            >
              <img
                src={LOGO_URL}
                alt="FloraIQ"
                className="h-60 w-auto object-contain"
              />
            </a>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-xs">
              Portal público de transparência ambiental com dados de arborização urbana, áreas verdes, UCs e indicadores do patrimônio verde municipal.
            </p>
          </div>

          {/* Links */}
          <div className="md:col-span-1">
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">Navegação</h4>
            <ul className="space-y-2">
              {publicNavLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      onNavigate(link.href);
                    }}
                    className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
            <h4 className="text-sm font-semibold text-foreground-950 mt-6 mb-3">Institucional</h4>
            <ul className="space-y-2">
              <li>
                <a href="#" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors">Política de Dados</a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors">Contato</a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-1">
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">Contato</h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="mailto:cena@cenatech.com.br"
                  className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors"
                >
                  cena@cenatech.com.br
                </a>
              </li>
              <li>
                <a
                  href="tel:+5562998462147"
                  className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors"
                >
                  (62) 99846-2147
                </a>
              </li>
              <li>
                <a
                  href="https://dbda.com.br/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors"
                >
                  dbda.com.br
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-background-200/70 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} FloraIQ. Todos os direitos reservados.
          </p>
          <a
            href="https://dbda.com.br/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors"
          >
            Powered by DBDA
          </a>
        </div>
      </div>
    </footer>
  );
}